/**
 * Comprehensive Global Port Database
 * Includes 500+ ports from all major shipping regions
 * Organized by country, sorted alphabetically
 */

export const portsByCountry = {
  // ============================================
  // CARIBBEAN
  // ============================================
  "Anguilla": [
    { code: "AXA", name: "Wallblake Airport", type: "air" },
    { code: "ANG", name: "Road Bay", type: "sea" }
  ],
  "Antigua and Barbuda": [
    { code: "ANU", name: "V.C. Bird International Airport", type: "air" },
    { code: "SJO", name: "St. John's", type: "sea" }
  ],
  "Aruba": [
    { code: "AUA", name: "Queen Beatrix International Airport", type: "air" },
    { code: "ORJ", name: "Oranjestad", type: "sea" },
    { code: "SNI", name: "San Nicolas", type: "sea" }
  ],
  "Bahamas": [
    // New Providence (Nassau)
    { code: "NAS", name: "Nassau (Lynden Pindling International Airport)", type: "air" },
    { code: "PGD", name: "Prince George Dock (Nassau)", type: "sea" },
    { code: "AWK", name: "Arawak Port (Nassau)", type: "sea" },
    { code: "POT", name: "Potter's Cay (Nassau)", type: "sea" },
    // Grand Bahama
    { code: "FPO", name: "Freeport (Grand Bahama International Airport)", type: "air" },
    { code: "FRP", name: "Freeport Harbour (Container Port)", type: "sea" },
    { code: "LUC", name: "Port Lucaya", type: "sea" },
    { code: "WTD", name: "West End", type: "sea" },
    // Abaco Islands
    { code: "MHH", name: "Marsh Harbour (Leonard M. Thompson Airport)", type: "air" },
    { code: "MHP", name: "Marsh Harbour Port", type: "sea" },
    { code: "TCB", name: "Treasure Cay Airport", type: "air" },
    { code: "TCP", name: "Treasure Cay Marina", type: "sea" },
    { code: "GTC", name: "Green Turtle Cay", type: "sea" },
    { code: "WKR", name: "Walker's Cay", type: "sea" },
    { code: "SPA", name: "Spanish Cay", type: "both" },
    { code: "SAP", name: "Sandy Point", type: "both" },
    // Eleuthera & Harbour Island
    { code: "GHB", name: "Governor's Harbour Airport", type: "air" },
    { code: "GHP", name: "Governor's Harbour Dock", type: "sea" },
    { code: "ELH", name: "North Eleuthera Airport", type: "air" },
    { code: "RSD", name: "Rock Sound Airport", type: "air" },
    { code: "RSP", name: "Rock Sound Dock", type: "sea" },
    { code: "HBI", name: "Harbour Island", type: "sea" },
    { code: "SPW", name: "Spanish Wells", type: "sea" },
    { code: "CEL", name: "Cape Eleuthera", type: "sea" },
    { code: "HMC", name: "Half Moon Cay", type: "sea" },
    // Exuma
    { code: "GGT", name: "George Town (Exuma International Airport)", type: "air" },
    { code: "GTP", name: "George Town Dock (Exuma)", type: "sea" },
    { code: "STC", name: "Staniel Cay", type: "both" },
    { code: "BPT", name: "Black Point (Exuma)", type: "both" },
    { code: "EMB", name: "Emerald Bay Marina", type: "sea" },
    // Bimini
    { code: "BIM", name: "South Bimini Airport", type: "air" },
    { code: "NSB", name: "North Bimini (Resorts World Marina)", type: "sea" },
    { code: "CAT", name: "Cat Cay", type: "sea" },
    // Berry Islands
    { code: "GHC", name: "Great Harbour Cay Airport", type: "air" },
    { code: "GHP", name: "Great Harbour Cay Marina", type: "sea" },
    { code: "CXY", name: "Chub Cay", type: "both" },
    // Andros
    { code: "SAQ", name: "San Andros Airport", type: "air" },
    { code: "FRE", name: "Fresh Creek (Andros Town Airport)", type: "air" },
    { code: "TZN", name: "Congo Town Airport (South Andros)", type: "air" },
    // Long Island
    { code: "SML", name: "Stella Maris Airport", type: "air" },
    { code: "LGI", name: "Deadman's Cay Airport", type: "air" },
    // Cat Island
    { code: "TBI", name: "New Bight Airport (Cat Island)", type: "air" },
    { code: "ATC", name: "Arthur's Town Airport", type: "air" },
    // San Salvador
    { code: "ZSA", name: "San Salvador Airport", type: "air" },
    // Inagua
    { code: "IGA", name: "Matthew Town Airport (Inagua)", type: "air" },
    { code: "IGP", name: "Matthew Town Dock (Inagua)", type: "sea" },
    // Mayaguana
    { code: "MYG", name: "Abraham's Bay Airport (Mayaguana)", type: "air" },
    // Crooked Island
    { code: "CRI", name: "Colonel Hill Airport (Crooked Island)", type: "air" },
    // Acklins
    { code: "AXP", name: "Spring Point Airport (Acklins)", type: "air" },
    // Rum Cay
    { code: "RCY", name: "Rum Cay Airport", type: "air" },
    // Ragged Island
    { code: "RGI", name: "Duncan Town (Ragged Island)", type: "air" }
  ],
  "Barbados": [
    { code: "BGI", name: "Grantley Adams International Airport", type: "air" },
    { code: "BRI", name: "Bridgetown", type: "sea" }
  ],
  "Bermuda": [
    { code: "BDA", name: "L.F. Wade International Airport", type: "air" },
    { code: "HML", name: "Hamilton", type: "sea" }
  ],
  "Bonaire": [
    { code: "BON", name: "Flamingo International Airport", type: "air" },
    { code: "KRA", name: "Kralendijk", type: "sea" }
  ],
  "British Virgin Islands": [
    { code: "EIS", name: "Terrance B. Lettsome Airport", type: "air" },
    { code: "TOV", name: "Road Town (Tortola)", type: "sea" }
  ],
  "Cayman Islands": [
    { code: "GCM", name: "Owen Roberts International Airport", type: "air" },
    { code: "GEO", name: "George Town", type: "sea" }
  ],
  "Cuba": [
    { code: "HAV", name: "José Martí International Airport", type: "air" },
    { code: "HAB", name: "Havana Port", type: "sea" },
    { code: "SCU", name: "Santiago de Cuba", type: "both" },
    { code: "CFG", name: "Cienfuegos", type: "sea" },
    { code: "MAR", name: "Mariel", type: "sea" }
  ],
  "Curaçao": [
    { code: "CUR", name: "Curaçao International Airport", type: "air" },
    { code: "WIL", name: "Willemstad", type: "sea" }
  ],
  "Dominica": [
    { code: "DOM", name: "Douglas-Charles Airport", type: "air" },
    { code: "ROS", name: "Roseau", type: "sea" }
  ],
  "Dominican Republic": [
    { code: "SDQ", name: "Las Américas International Airport", type: "air" },
    { code: "PUJ", name: "Punta Cana International Airport", type: "air" },
    { code: "STI", name: "Cibao International Airport", type: "air" },
    { code: "CAU", name: "Caucedo", type: "sea" },
    { code: "RHI", name: "Rio Haina", type: "sea" },
    { code: "SDO", name: "Santo Domingo Port", type: "sea" },
    { code: "PTA", name: "Puerto Plata", type: "sea" }
  ],
  "Grenada": [
    { code: "GND", name: "Maurice Bishop International Airport", type: "air" },
    { code: "STG", name: "St. George's", type: "sea" }
  ],
  "Guadeloupe": [
    { code: "PTP", name: "Pointe-à-Pitre International Airport", type: "air" },
    { code: "PAP", name: "Pointe-à-Pitre Port", type: "sea" }
  ],
  "Haiti": [
    { code: "PAP", name: "Toussaint Louverture International Airport", type: "air" },
    { code: "PAU", name: "Port-au-Prince", type: "sea" },
    { code: "CAP", name: "Cap-Haïtien", type: "both" }
  ],
  "Jamaica": [
    { code: "KIN", name: "Norman Manley International Airport", type: "air" },
    { code: "MBJ", name: "Sangster International Airport", type: "air" },
    { code: "KNG", name: "Kingston Port", type: "sea" },
    { code: "MOB", name: "Montego Bay Freeport", type: "sea" }
  ],
  "Martinique": [
    { code: "FDF", name: "Martinique Aimé Césaire Airport", type: "air" },
    { code: "FOF", name: "Fort-de-France", type: "sea" }
  ],
  "Montserrat": [
    { code: "MNI", name: "John A. Osborne Airport", type: "air" }
  ],
  "Puerto Rico": [
    { code: "SJU", name: "Luis Muñoz Marín International Airport", type: "air" },
    { code: "SJN", name: "San Juan Port", type: "sea" },
    { code: "PON", name: "Ponce", type: "sea" }
  ],
  "Saint Barthélemy": [
    { code: "SBH", name: "Gustaf III Airport", type: "air" },
    { code: "GUS", name: "Gustavia", type: "sea" }
  ],
  "Saint Kitts and Nevis": [
    { code: "SKB", name: "Robert L. Bradshaw International Airport", type: "air" },
    { code: "BAS", name: "Basseterre", type: "sea" }
  ],
  "Saint Lucia": [
    { code: "UVF", name: "Hewanorra International Airport", type: "air" },
    { code: "CAS", name: "Castries", type: "sea" },
    { code: "VIF", name: "Vieux Fort", type: "sea" }
  ],
  "Sint Maarten": [
    { code: "SXM", name: "Princess Juliana International Airport", type: "air" },
    { code: "PHI", name: "Philipsburg", type: "sea" }
  ],
  "Saint Vincent and the Grenadines": [
    { code: "SVD", name: "Argyle International Airport", type: "air" },
    { code: "KTN", name: "Kingstown", type: "sea" }
  ],
  "Trinidad and Tobago": [
    { code: "POS", name: "Piarco International Airport", type: "air" },
    { code: "TAB", name: "A.N.R. Robinson International Airport", type: "air" },
    { code: "PTN", name: "Port of Spain", type: "sea" },
    { code: "PLI", name: "Point Lisas", type: "sea" }
  ],
  "Turks and Caicos Islands": [
    { code: "PLS", name: "Providenciales International Airport", type: "air" },
    { code: "GDT", name: "Grand Turk", type: "both" }
  ],
  "US Virgin Islands": [
    { code: "STT", name: "Cyril E. King Airport (St. Thomas)", type: "air" },
    { code: "STX", name: "Henry E. Rohlsen Airport (St. Croix)", type: "air" },
    { code: "CHA", name: "Charlotte Amalie", type: "sea" },
    { code: "CHR", name: "Christiansted", type: "sea" }
  ],

  // ============================================
  // CENTRAL AMERICA
  // ============================================
  "Belize": [
    { code: "BZE", name: "Philip S. W. Goldson International Airport", type: "air" },
    { code: "BZC", name: "Belize City Port", type: "sea" },
    { code: "BGK", name: "Big Creek", type: "sea" }
  ],
  "Costa Rica": [
    { code: "SJO", name: "Juan Santamaría International Airport", type: "air" },
    { code: "LIR", name: "Daniel Oduber Quirós International Airport", type: "air" },
    { code: "LIM", name: "Puerto Limón", type: "sea" },
    { code: "MOI", name: "Moín", type: "sea" },
    { code: "CAL", name: "Puerto Caldera", type: "sea" }
  ],
  "El Salvador": [
    { code: "SAL", name: "Monseñor Óscar Arnulfo Romero International Airport", type: "air" },
    { code: "ACA", name: "Acajutla", type: "sea" }
  ],
  "Guatemala": [
    { code: "GUA", name: "La Aurora International Airport", type: "air" },
    { code: "PBR", name: "Puerto Barrios", type: "sea" },
    { code: "STT", name: "Santo Tomás de Castilla", type: "sea" },
    { code: "PRQ", name: "Puerto Quetzal", type: "sea" }
  ],
  "Honduras": [
    { code: "TGU", name: "Toncontín International Airport", type: "air" },
    { code: "SAP", name: "Ramón Villeda Morales International Airport", type: "air" },
    { code: "PCO", name: "Puerto Cortés", type: "sea" },
    { code: "LCE", name: "La Ceiba", type: "both" },
    { code: "RTB", name: "Roatán", type: "both" }
  ],
  "Nicaragua": [
    { code: "MGA", name: "Augusto C. Sandino International Airport", type: "air" },
    { code: "COR", name: "Corinto", type: "sea" },
    { code: "BEF", name: "Bluefields", type: "both" }
  ],
  "Panama": [
    { code: "PTY", name: "Tocumen International Airport", type: "air" },
    { code: "CRB", name: "Cristóbal (Colón)", type: "sea" },
    { code: "BAL", name: "Balboa", type: "sea" },
    { code: "MIT", name: "Manzanillo International Terminal", type: "sea" },
    { code: "COL", name: "Colón Free Zone", type: "sea" }
  ],

  // ============================================
  // SOUTH AMERICA
  // ============================================
  "Argentina": [
    { code: "EZE", name: "Ministro Pistarini International Airport", type: "air" },
    { code: "AEP", name: "Jorge Newbery Airfield", type: "air" },
    { code: "BUE", name: "Buenos Aires Port", type: "sea" },
    { code: "ROS", name: "Rosario", type: "sea" },
    { code: "BAH", name: "Bahía Blanca", type: "sea" },
    { code: "USH", name: "Ushuaia", type: "both" }
  ],
  "Bolivia": [
    { code: "VVI", name: "Viru Viru International Airport", type: "air" },
    { code: "LPB", name: "El Alto International Airport", type: "air" }
  ],
  "Brazil": [
    { code: "GRU", name: "São Paulo–Guarulhos International Airport", type: "air" },
    { code: "GIG", name: "Rio de Janeiro–Galeão International Airport", type: "air" },
    { code: "VCP", name: "Viracopos International Airport", type: "air" },
    { code: "SSA", name: "Salvador International Airport", type: "air" },
    { code: "SAN", name: "Santos", type: "sea" },
    { code: "RIO", name: "Rio de Janeiro Port", type: "sea" },
    { code: "PNG", name: "Paranaguá", type: "sea" },
    { code: "ITJ", name: "Itajaí", type: "sea" },
    { code: "NVT", name: "Navegantes", type: "sea" },
    { code: "RGR", name: "Rio Grande", type: "sea" },
    { code: "MAN", name: "Manaus", type: "both" },
    { code: "REC", name: "Recife (Suape)", type: "both" },
    { code: "FOR", name: "Fortaleza (Pecém)", type: "both" },
    { code: "VIX", name: "Vitória", type: "sea" }
  ],
  "Chile": [
    { code: "SCL", name: "Arturo Merino Benítez International Airport", type: "air" },
    { code: "VAL", name: "Valparaíso", type: "sea" },
    { code: "SAI", name: "San Antonio", type: "sea" },
    { code: "TAL", name: "Talcahuano", type: "sea" },
    { code: "ANF", name: "Antofagasta", type: "both" },
    { code: "IQQ", name: "Iquique", type: "both" },
    { code: "PUQ", name: "Punta Arenas", type: "both" }
  ],
  "Colombia": [
    { code: "BOG", name: "El Dorado International Airport", type: "air" },
    { code: "MDE", name: "José María Córdova International Airport", type: "air" },
    { code: "CLO", name: "Alfonso Bonilla Aragón International Airport", type: "air" },
    { code: "CTG", name: "Cartagena", type: "both" },
    { code: "BAQ", name: "Barranquilla", type: "both" },
    { code: "BUN", name: "Buenaventura", type: "sea" },
    { code: "SMR", name: "Santa Marta", type: "both" },
    { code: "TLU", name: "Turbo", type: "sea" }
  ],
  "Ecuador": [
    { code: "UIO", name: "Mariscal Sucre International Airport", type: "air" },
    { code: "GYE", name: "José Joaquín de Olmedo International Airport", type: "air" },
    { code: "GUA", name: "Guayaquil Port", type: "sea" },
    { code: "MAN", name: "Manta", type: "sea" },
    { code: "ESM", name: "Esmeraldas", type: "sea" }
  ],
  "French Guiana": [
    { code: "CAY", name: "Félix Eboué Airport", type: "air" },
    { code: "DEG", name: "Dégrad des Cannes", type: "sea" }
  ],
  "Guyana": [
    { code: "GEO", name: "Cheddi Jagan International Airport", type: "air" },
    { code: "GEP", name: "Georgetown Port", type: "sea" }
  ],
  "Paraguay": [
    { code: "ASU", name: "Silvio Pettirossi International Airport", type: "air" }
  ],
  "Peru": [
    { code: "LIM", name: "Jorge Chávez International Airport", type: "air" },
    { code: "CAL", name: "Callao", type: "sea" },
    { code: "PAI", name: "Paita", type: "sea" },
    { code: "ILO", name: "Ilo", type: "sea" },
    { code: "MTC", name: "Matarani", type: "sea" }
  ],
  "Suriname": [
    { code: "PBM", name: "Johan Adolf Pengel International Airport", type: "air" },
    { code: "PAR", name: "Paramaribo Port", type: "sea" }
  ],
  "Uruguay": [
    { code: "MVD", name: "Carrasco International Airport", type: "air" },
    { code: "MON", name: "Montevideo Port", type: "sea" }
  ],
  "Venezuela": [
    { code: "CCS", name: "Simón Bolívar International Airport", type: "air" },
    { code: "LAG", name: "La Guaira", type: "sea" },
    { code: "MAR", name: "Maracaibo", type: "both" },
    { code: "PCA", name: "Puerto Cabello", type: "sea" },
    { code: "CUM", name: "Cumaná", type: "sea" },
    { code: "PZO", name: "Puerto Ordaz", type: "sea" }
  ],

  // ============================================
  // NORTH AMERICA
  // ============================================
  "Canada": [
    { code: "YYZ", name: "Toronto Pearson International Airport", type: "air" },
    { code: "YUL", name: "Montréal–Trudeau International Airport", type: "air" },
    { code: "YVR", name: "Vancouver International Airport", type: "air" },
    { code: "YYC", name: "Calgary International Airport", type: "air" },
    { code: "YHZ", name: "Halifax Stanfield International Airport", type: "air" },
    { code: "YWG", name: "Winnipeg James Armstrong Richardson Airport", type: "air" },
    { code: "TOR", name: "Port of Toronto", type: "sea" },
    { code: "MTL", name: "Port of Montreal", type: "sea" },
    { code: "VAN", name: "Port of Vancouver", type: "sea" },
    { code: "HAL", name: "Port of Halifax", type: "sea" },
    { code: "SJN", name: "Port of Saint John", type: "sea" },
    { code: "PRU", name: "Port of Prince Rupert", type: "sea" }
  ],
  "Mexico": [
    { code: "MEX", name: "Mexico City International Airport", type: "air" },
    { code: "GDL", name: "Guadalajara International Airport", type: "air" },
    { code: "MTY", name: "Monterrey International Airport", type: "air" },
    { code: "CUN", name: "Cancún International Airport", type: "air" },
    { code: "TIJ", name: "Tijuana International Airport", type: "air" },
    { code: "VER", name: "Veracruz", type: "both" },
    { code: "MZT", name: "Mazatlán", type: "both" },
    { code: "MAN", name: "Manzanillo", type: "sea" },
    { code: "LZC", name: "Lázaro Cárdenas", type: "sea" },
    { code: "ALT", name: "Altamira", type: "sea" },
    { code: "TAM", name: "Tampico", type: "sea" },
    { code: "PRO", name: "Progreso", type: "sea" },
    { code: "ENS", name: "Ensenada", type: "sea" }
  ],
  "United States": [
    // ==================== MAJOR AIRPORTS ====================
    { code: "MIA", name: "Miami International Airport", type: "air" },
    { code: "FLL", name: "Fort Lauderdale–Hollywood International Airport", type: "air" },
    { code: "JFK", name: "John F. Kennedy International Airport", type: "air" },
    { code: "EWR", name: "Newark Liberty International Airport", type: "air" },
    { code: "LAX", name: "Los Angeles International Airport", type: "air" },
    { code: "ORD", name: "O'Hare International Airport", type: "air" },
    { code: "ATL", name: "Hartsfield–Jackson Atlanta International Airport", type: "air" },
    { code: "DFW", name: "Dallas/Fort Worth International Airport", type: "air" },
    { code: "IAH", name: "George Bush Intercontinental Airport", type: "air" },
    { code: "SFO", name: "San Francisco International Airport", type: "air" },
    { code: "SEA", name: "Seattle–Tacoma International Airport", type: "air" },
    { code: "BOS", name: "Boston Logan International Airport", type: "air" },
    { code: "PHX", name: "Phoenix Sky Harbor International Airport", type: "air" },
    { code: "DEN", name: "Denver International Airport", type: "air" },
    { code: "MCO", name: "Orlando International Airport", type: "air" },
    { code: "MSP", name: "Minneapolis–Saint Paul International Airport", type: "air" },
    { code: "DTW", name: "Detroit Metropolitan Airport", type: "air" },
    { code: "CLT", name: "Charlotte Douglas International Airport", type: "air" },
    { code: "LAS", name: "Las Vegas Harry Reid International Airport", type: "air" },
    { code: "BWI", name: "Baltimore/Washington International Airport", type: "air" },
    { code: "SLC", name: "Salt Lake City International Airport", type: "air" },
    { code: "SAN", name: "San Diego International Airport", type: "air" },
    { code: "TPA", name: "Tampa International Airport", type: "air" },
    { code: "PDX", name: "Portland International Airport", type: "air" },
    { code: "STL", name: "St. Louis Lambert International Airport", type: "air" },
    { code: "MCI", name: "Kansas City International Airport", type: "air" },
    { code: "AUS", name: "Austin-Bergstrom International Airport", type: "air" },
    { code: "RDU", name: "Raleigh-Durham International Airport", type: "air" },
    { code: "IND", name: "Indianapolis International Airport", type: "air" },
    { code: "CMH", name: "John Glenn Columbus International Airport", type: "air" },
    { code: "PIT", name: "Pittsburgh International Airport", type: "air" },
    { code: "CLE", name: "Cleveland Hopkins International Airport", type: "air" },
    { code: "CVG", name: "Cincinnati/Northern Kentucky International Airport", type: "air" },
    { code: "MKE", name: "Milwaukee Mitchell International Airport", type: "air" },
    { code: "BNA", name: "Nashville International Airport", type: "air" },
    { code: "MSY", name: "New Orleans Louis Armstrong International Airport", type: "air" },
    { code: "MEM", name: "Memphis International Airport", type: "air" },
    { code: "SAT", name: "San Antonio International Airport", type: "air" },
    { code: "OKC", name: "Will Rogers World Airport (Oklahoma City)", type: "air" },
    { code: "ABQ", name: "Albuquerque International Sunport", type: "air" },
    { code: "HNL", name: "Honolulu Daniel K. Inouye International Airport", type: "air" },
    { code: "ANC", name: "Ted Stevens Anchorage International Airport", type: "air" },
    // ==================== EAST COAST SEAPORTS ====================
    // Maine
    { code: "PWM", name: "Port of Portland (Maine)", type: "sea" },
    { code: "EAS", name: "Port of Eastport", type: "sea" },
    { code: "SEA", name: "Port of Searsport", type: "sea" },
    { code: "BAN", name: "Port of Bangor", type: "sea" },
    // New Hampshire
    { code: "PSM", name: "Port of Portsmouth (NH)", type: "sea" },
    // Massachusetts
    { code: "BOS", name: "Port of Boston (Conley Terminal)", type: "sea" },
    { code: "NBD", name: "Port of New Bedford", type: "sea" },
    { code: "FAL", name: "Port of Fall River", type: "sea" },
    { code: "GLO", name: "Port of Gloucester", type: "sea" },
    { code: "SAL", name: "Port of Salem", type: "sea" },
    // Rhode Island
    { code: "PVD", name: "Port of Providence", type: "sea" },
    { code: "QUO", name: "Port of Quonset Point", type: "sea" },
    { code: "NPT", name: "Port of Newport (RI)", type: "sea" },
    // Connecticut
    { code: "NHA", name: "Port of New Haven", type: "sea" },
    { code: "BPT", name: "Port of Bridgeport", type: "sea" },
    { code: "NLN", name: "Port of New London", type: "sea" },
    // New York
    { code: "NYK", name: "Port of New York/New Jersey", type: "sea" },
    { code: "NYE", name: "Port Newark-Elizabeth Marine Terminal", type: "sea" },
    { code: "NYG", name: "Global Container Terminal (Bayonne)", type: "sea" },
    { code: "NYR", name: "Red Hook Container Terminal (Brooklyn)", type: "sea" },
    { code: "NYC", name: "New York Container Terminal (Staten Island)", type: "sea" },
    { code: "ALB", name: "Port of Albany", type: "sea" },
    { code: "BUF", name: "Port of Buffalo", type: "sea" },
    { code: "OSW", name: "Port of Oswego", type: "sea" },
    { code: "OGD", name: "Port of Ogdensburg", type: "sea" },
    // New Jersey
    { code: "CAM", name: "Port of Camden", type: "sea" },
    { code: "PAU", name: "Port of Paulsboro", type: "sea" },
    // Pennsylvania
    { code: "PHL", name: "Port of Philadelphia (PhilaPort)", type: "sea" },
    { code: "CHE", name: "Port of Chester", type: "sea" },
    { code: "MAR", name: "Port of Marcus Hook", type: "sea" },
    // Delaware
    { code: "WDE", name: "Port of Wilmington (Delaware)", type: "sea" },
    // Maryland
    { code: "BAL", name: "Port of Baltimore", type: "sea" },
    { code: "SPT", name: "Sparrows Point Terminal", type: "sea" },
    // Virginia
    { code: "NFK", name: "Port of Norfolk (Virginia International Terminals)", type: "sea" },
    { code: "NNS", name: "Newport News Marine Terminal", type: "sea" },
    { code: "PMV", name: "Portsmouth Marine Terminal", type: "sea" },
    { code: "VIG", name: "Virginia International Gateway", type: "sea" },
    { code: "RIC", name: "Port of Richmond (VA)", type: "sea" },
    // North Carolina
    { code: "WNC", name: "Port of Wilmington (North Carolina)", type: "sea" },
    { code: "MHC", name: "Port of Morehead City", type: "sea" },
    // South Carolina
    { code: "CHS", name: "Port of Charleston", type: "sea" },
    { code: "WAD", name: "Wando Welch Terminal (Charleston)", type: "sea" },
    { code: "NPD", name: "North Charleston Terminal", type: "sea" },
    { code: "HUG", name: "Hugh K. Leatherman Terminal (Charleston)", type: "sea" },
    { code: "GEO", name: "Port of Georgetown (SC)", type: "sea" },
    // Georgia
    { code: "SAV", name: "Port of Savannah (Garden City Terminal)", type: "sea" },
    { code: "OCT", name: "Ocean Terminal (Savannah)", type: "sea" },
    { code: "BRU", name: "Port of Brunswick", type: "sea" },
    // Florida - East Coast
    { code: "JAX", name: "Port of Jacksonville (JAXPORT)", type: "sea" },
    { code: "BLO", name: "Blount Island Terminal (Jacksonville)", type: "sea" },
    { code: "TAL", name: "Talleyrand Marine Terminal (Jacksonville)", type: "sea" },
    { code: "PCA", name: "Port Canaveral", type: "sea" },
    { code: "PEV", name: "Port Everglades (Fort Lauderdale)", type: "sea" },
    { code: "MIP", name: "Port Miami (PortMiami)", type: "sea" },
    { code: "WPB", name: "Port of Palm Beach", type: "sea" },
    { code: "FTP", name: "Port of Fort Pierce", type: "sea" },
    // ==================== GULF COAST SEAPORTS ====================
    // Florida - Gulf Coast
    { code: "TPA", name: "Port Tampa Bay", type: "sea" },
    { code: "MAN", name: "Port Manatee", type: "sea" },
    { code: "STB", name: "Port of St. Petersburg", type: "sea" },
    { code: "PMR", name: "Port of Panama City", type: "sea" },
    { code: "PEN", name: "Port of Pensacola", type: "sea" },
    { code: "FTM", name: "Port of Fort Myers", type: "sea" },
    { code: "KWE", name: "Port of Key West", type: "sea" },
    // Alabama
    { code: "MOB", name: "Port of Mobile", type: "sea" },
    { code: "APM", name: "APM Terminals Mobile", type: "sea" },
    // Mississippi
    { code: "GPT", name: "Port of Gulfport", type: "sea" },
    { code: "PAS", name: "Port of Pascagoula", type: "sea" },
    // Louisiana
    { code: "NOL", name: "Port of New Orleans", type: "sea" },
    { code: "SPL", name: "South Louisiana Port (Port of South Louisiana)", type: "sea" },
    { code: "BTR", name: "Port of Baton Rouge", type: "sea" },
    { code: "LAK", name: "Port of Lake Charles", type: "sea" },
    { code: "PLA", name: "Port of Plaquemines", type: "sea" },
    { code: "STB", name: "Port of St. Bernard", type: "sea" },
    { code: "GRE", name: "Port of Greater Baton Rouge", type: "sea" },
    // Texas
    { code: "HOU", name: "Port of Houston", type: "sea" },
    { code: "BAY", name: "Port of Baytown", type: "sea" },
    { code: "TEX", name: "Port of Texas City", type: "sea" },
    { code: "GAL", name: "Port of Galveston", type: "sea" },
    { code: "FRE", name: "Port Freeport", type: "sea" },
    { code: "COR", name: "Port of Corpus Christi", type: "sea" },
    { code: "BRO", name: "Port of Brownsville", type: "sea" },
    { code: "PIA", name: "Port Isabel-South Padre", type: "sea" },
    { code: "VIC", name: "Port of Victoria", type: "sea" },
    { code: "PLA", name: "Port of Port Lavaca-Point Comfort", type: "sea" },
    { code: "HAR", name: "Port of Harlingen", type: "sea" },
    { code: "BEA", name: "Port of Beaumont", type: "sea" },
    { code: "POA", name: "Port of Port Arthur", type: "sea" },
    { code: "ORA", name: "Port of Orange", type: "sea" },
    { code: "SAB", name: "Port of Sabine Pass", type: "sea" },
    // ==================== WEST COAST SEAPORTS ====================
    // California
    { code: "LAP", name: "Port of Los Angeles", type: "sea" },
    { code: "LBP", name: "Port of Long Beach", type: "sea" },
    { code: "SDP", name: "Port of San Diego", type: "sea" },
    { code: "OAK", name: "Port of Oakland", type: "sea" },
    { code: "SFB", name: "Port of San Francisco", type: "sea" },
    { code: "RIC", name: "Port of Richmond (CA)", type: "sea" },
    { code: "SAC", name: "Port of Sacramento (West Sacramento)", type: "sea" },
    { code: "STK", name: "Port of Stockton", type: "sea" },
    { code: "RED", name: "Port of Redwood City", type: "sea" },
    { code: "HUE", name: "Port of Hueneme", type: "sea" },
    { code: "VEN", name: "Port of Ventura", type: "sea" },
    // Oregon
    { code: "PDX", name: "Port of Portland (Oregon)", type: "sea" },
    { code: "AST", name: "Port of Astoria", type: "sea" },
    { code: "COO", name: "Port of Coos Bay", type: "sea" },
    { code: "NEW", name: "Port of Newport (Oregon)", type: "sea" },
    { code: "ST", name: "Port of St. Helens", type: "sea" },
    // Washington
    { code: "SEP", name: "Port of Seattle", type: "sea" },
    { code: "TAC", name: "Port of Tacoma", type: "sea" },
    { code: "NWT", name: "Northwest Seaport Alliance (Seattle-Tacoma)", type: "sea" },
    { code: "VAN", name: "Port of Vancouver (Washington)", type: "sea" },
    { code: "LON", name: "Port of Longview", type: "sea" },
    { code: "KAL", name: "Port of Kalama", type: "sea" },
    { code: "GRH", name: "Port of Grays Harbor", type: "sea" },
    { code: "OLY", name: "Port of Olympia", type: "sea" },
    { code: "BEL", name: "Port of Bellingham", type: "sea" },
    { code: "EVE", name: "Port of Everett", type: "sea" },
    { code: "ANR", name: "Port of Anacortes", type: "sea" },
    // ==================== ALASKA SEAPORTS ====================
    { code: "ANC", name: "Port of Anchorage", type: "sea" },
    { code: "JUN", name: "Port of Juneau", type: "sea" },
    { code: "KET", name: "Port of Ketchikan", type: "sea" },
    { code: "SIT", name: "Port of Sitka", type: "sea" },
    { code: "SKA", name: "Port of Skagway", type: "sea" },
    { code: "VAL", name: "Port of Valdez", type: "sea" },
    { code: "SEW", name: "Port of Seward", type: "sea" },
    { code: "KOD", name: "Port of Kodiak", type: "sea" },
    { code: "DUT", name: "Port of Dutch Harbor (Unalaska)", type: "sea" },
    { code: "NOM", name: "Port of Nome", type: "sea" },
    { code: "WHI", name: "Port of Whittier", type: "sea" },
    // ==================== HAWAII SEAPORTS ====================
    { code: "HNL", name: "Port of Honolulu", type: "sea" },
    { code: "KAH", name: "Port of Kahului (Maui)", type: "sea" },
    { code: "HIL", name: "Port of Hilo (Hawaii)", type: "sea" },
    { code: "KAW", name: "Port of Kawaihae (Hawaii)", type: "sea" },
    { code: "NAW", name: "Port of Nawiliwili (Kauai)", type: "sea" },
    { code: "BAR", name: "Port of Barbers Point (Oahu)", type: "sea" },
    // ==================== GREAT LAKES SEAPORTS ====================
    // Michigan
    { code: "DTR", name: "Port of Detroit", type: "sea" },
    { code: "MQT", name: "Port of Marquette", type: "sea" },
    { code: "ESC", name: "Port of Escanaba", type: "sea" },
    { code: "STI", name: "Port of Sault Ste. Marie", type: "sea" },
    { code: "MUS", name: "Port of Muskegon", type: "sea" },
    { code: "HOL", name: "Port of Holland", type: "sea" },
    // Ohio
    { code: "CLE", name: "Port of Cleveland", type: "sea" },
    { code: "TOL", name: "Port of Toledo", type: "sea" },
    { code: "ASH", name: "Port of Ashtabula", type: "sea" },
    { code: "CNT", name: "Port of Conneaut", type: "sea" },
    { code: "LOR", name: "Port of Lorain", type: "sea" },
    // Indiana
    { code: "BHB", name: "Port of Burns Harbor (Indiana)", type: "sea" },
    { code: "IHP", name: "Indiana Harbor Port", type: "sea" },
    // Illinois
    { code: "CHI", name: "Port of Chicago", type: "sea" },
    { code: "CAL", name: "Port of Calumet (Chicago)", type: "sea" },
    // Wisconsin
    { code: "MIL", name: "Port of Milwaukee", type: "sea" },
    { code: "GRB", name: "Port of Green Bay", type: "sea" },
    { code: "SUP", name: "Port of Superior", type: "sea" },
    { code: "MAN", name: "Port of Manitowoc", type: "sea" },
    // Minnesota
    { code: "DUL", name: "Port of Duluth-Superior", type: "sea" },
    { code: "TWO", name: "Port of Two Harbors", type: "sea" },
    { code: "SIL", name: "Port of Silver Bay", type: "sea" },
    // ==================== INLAND RIVER PORTS ====================
    // Mississippi River
    { code: "MEM", name: "Port of Memphis", type: "sea" },
    { code: "STL", name: "Port of St. Louis", type: "sea" },
    { code: "GRE", name: "Port of Greenville (MS)", type: "sea" },
    { code: "VIC", name: "Port of Vicksburg", type: "sea" },
    { code: "NAT", name: "Port of Natchez", type: "sea" },
    { code: "HEL", name: "Port of Helena (AR)", type: "sea" },
    { code: "CAI", name: "Port of Cairo", type: "sea" },
    // Ohio River
    { code: "CIN", name: "Port of Cincinnati", type: "sea" },
    { code: "LOU", name: "Port of Louisville", type: "sea" },
    { code: "PAD", name: "Port of Paducah", type: "sea" },
    { code: "EVA", name: "Port of Evansville", type: "sea" },
    { code: "HUN", name: "Port of Huntington (WV)", type: "sea" },
    { code: "PIT", name: "Port of Pittsburgh", type: "sea" },
    // Columbia River
    { code: "UMA", name: "Port of Umatilla", type: "sea" },
    { code: "MOR", name: "Port of Morrow", type: "sea" },
    // ==================== US TERRITORIES ====================
    // Puerto Rico (separate from Caribbean)
    { code: "SJP", name: "Port of San Juan (Puerto Rico)", type: "sea" },
    { code: "POP", name: "Port of Ponce (Puerto Rico)", type: "sea" },
    // US Virgin Islands (separate from Caribbean)
    { code: "CHA", name: "Port of Charlotte Amalie (St. Thomas)", type: "sea" },
    { code: "CHR", name: "Port of Christiansted (St. Croix)", type: "sea" },
    { code: "FRE", name: "Port of Frederiksted (St. Croix)", type: "sea" },
    // Guam
    { code: "APG", name: "Port of Apra (Guam)", type: "sea" }
  ],

  // ============================================
  // EUROPE - WESTERN
  // ============================================
  "Austria": [
    { code: "VIE", name: "Vienna International Airport", type: "air" }
  ],
  "Belgium": [
    { code: "BRU", name: "Brussels Airport", type: "air" },
    { code: "LGG", name: "Liège Airport", type: "air" },
    { code: "ANT", name: "Port of Antwerp", type: "sea" },
    { code: "ZEE", name: "Zeebrugge", type: "sea" },
    { code: "GHE", name: "Ghent", type: "sea" }
  ],
  "France": [
    { code: "CDG", name: "Paris Charles de Gaulle Airport", type: "air" },
    { code: "ORY", name: "Paris Orly Airport", type: "air" },
    { code: "LYS", name: "Lyon–Saint-Exupéry Airport", type: "air" },
    { code: "NCE", name: "Nice Côte d'Azur Airport", type: "air" },
    { code: "MRS", name: "Marseille Port", type: "sea" },
    { code: "HAV", name: "Le Havre", type: "sea" },
    { code: "DUN", name: "Dunkirk", type: "sea" },
    { code: "NAT", name: "Nantes Saint-Nazaire", type: "sea" },
    { code: "BOR", name: "Bordeaux", type: "sea" },
    { code: "FOS", name: "Fos-sur-Mer", type: "sea" }
  ],
  "Germany": [
    { code: "FRA", name: "Frankfurt Airport", type: "air" },
    { code: "MUC", name: "Munich Airport", type: "air" },
    { code: "DUS", name: "Düsseldorf Airport", type: "air" },
    { code: "TXL", name: "Berlin Brandenburg Airport", type: "air" },
    { code: "CGN", name: "Cologne Bonn Airport", type: "air" },
    { code: "HAM", name: "Hamburg Port", type: "sea" },
    { code: "BRE", name: "Bremerhaven", type: "sea" },
    { code: "WIL", name: "Wilhelmshaven", type: "sea" },
    { code: "ROS", name: "Rostock", type: "sea" },
    { code: "LUB", name: "Lübeck", type: "sea" },
    { code: "KIE", name: "Kiel", type: "sea" }
  ],
  "Ireland": [
    { code: "DUB", name: "Dublin Airport", type: "air" },
    { code: "ORK", name: "Cork Airport", type: "air" },
    { code: "DBP", name: "Dublin Port", type: "sea" },
    { code: "COP", name: "Cork Port", type: "sea" }
  ],
  "Luxembourg": [
    { code: "LUX", name: "Luxembourg Airport", type: "air" }
  ],
  "Netherlands": [
    { code: "AMS", name: "Amsterdam Airport Schiphol", type: "air" },
    { code: "RTM", name: "Port of Rotterdam", type: "sea" },
    { code: "AMP", name: "Port of Amsterdam", type: "sea" }
  ],
  "Switzerland": [
    { code: "ZRH", name: "Zürich Airport", type: "air" },
    { code: "GVA", name: "Geneva Airport", type: "air" },
    { code: "BSL", name: "Basel Rhine Port", type: "sea" }
  ],
  "United Kingdom": [
    { code: "LHR", name: "London Heathrow Airport", type: "air" },
    { code: "LGW", name: "London Gatwick Airport", type: "air" },
    { code: "STN", name: "London Stansted Airport", type: "air" },
    { code: "MAN", name: "Manchester Airport", type: "air" },
    { code: "EDI", name: "Edinburgh Airport", type: "air" },
    { code: "BHX", name: "Birmingham Airport", type: "air" },
    { code: "FEL", name: "Port of Felixstowe", type: "sea" },
    { code: "SOU", name: "Port of Southampton", type: "sea" },
    { code: "LON", name: "Port of London (Tilbury)", type: "sea" },
    { code: "LIV", name: "Port of Liverpool", type: "sea" },
    { code: "IMM", name: "Immingham", type: "sea" },
    { code: "GLA", name: "Port of Glasgow", type: "sea" },
    { code: "BEL", name: "Port of Belfast", type: "sea" },
    { code: "TEE", name: "Teesport", type: "sea" }
  ],

  // ============================================
  // EUROPE - SOUTHERN
  // ============================================
  "Cyprus": [
    { code: "LCA", name: "Larnaca International Airport", type: "air" },
    { code: "LIM", name: "Limassol Port", type: "sea" }
  ],
  "Greece": [
    { code: "ATH", name: "Athens International Airport", type: "air" },
    { code: "SKG", name: "Thessaloniki Airport", type: "air" },
    { code: "HER", name: "Heraklion Airport", type: "air" },
    { code: "PIR", name: "Piraeus", type: "sea" },
    { code: "THE", name: "Thessaloniki Port", type: "sea" },
    { code: "VOL", name: "Volos", type: "sea" },
    { code: "PAT", name: "Patras", type: "sea" },
    { code: "HRA", name: "Heraklion Port", type: "sea" }
  ],
  "Italy": [
    { code: "FCO", name: "Rome Fiumicino Airport", type: "air" },
    { code: "MXP", name: "Milan Malpensa Airport", type: "air" },
    { code: "LIN", name: "Milan Linate Airport", type: "air" },
    { code: "VCE", name: "Venice Marco Polo Airport", type: "air" },
    { code: "NAP", name: "Naples Airport", type: "air" },
    { code: "GEN", name: "Genoa Port", type: "sea" },
    { code: "LIV", name: "Livorno", type: "sea" },
    { code: "NAP", name: "Naples Port", type: "sea" },
    { code: "TRI", name: "Trieste", type: "sea" },
    { code: "VEN", name: "Venice Port", type: "sea" },
    { code: "RAV", name: "Ravenna", type: "sea" },
    { code: "GIO", name: "Gioia Tauro", type: "sea" },
    { code: "SAL", name: "Salerno", type: "sea" },
    { code: "PAL", name: "Palermo", type: "sea" },
    { code: "CAG", name: "Cagliari", type: "sea" },
    { code: "BAR", name: "Bari", type: "sea" },
    { code: "ANC", name: "Ancona", type: "sea" },
    { code: "CIV", name: "Civitavecchia", type: "sea" }
  ],
  "Malta": [
    { code: "MLA", name: "Malta International Airport", type: "air" },
    { code: "VAL", name: "Valletta Port", type: "sea" },
    { code: "MAR", name: "Marsaxlokk", type: "sea" }
  ],
  "Portugal": [
    { code: "LIS", name: "Lisbon Humberto Delgado Airport", type: "air" },
    { code: "OPO", name: "Porto Airport", type: "air" },
    { code: "FAO", name: "Faro Airport", type: "air" },
    { code: "LIS", name: "Lisbon Port", type: "sea" },
    { code: "LEI", name: "Leixões", type: "sea" },
    { code: "SIN", name: "Sines", type: "sea" },
    { code: "SET", name: "Setúbal", type: "sea" }
  ],
  "Spain": [
    { code: "MAD", name: "Madrid–Barajas Airport", type: "air" },
    { code: "BCN", name: "Barcelona–El Prat Airport", type: "air" },
    { code: "PMI", name: "Palma de Mallorca Airport", type: "air" },
    { code: "AGP", name: "Málaga Airport", type: "air" },
    { code: "ALC", name: "Alicante Airport", type: "air" },
    { code: "VLC", name: "Valencia Airport", type: "air" },
    { code: "BAR", name: "Port of Barcelona", type: "sea" },
    { code: "VAL", name: "Port of Valencia", type: "sea" },
    { code: "ALG", name: "Port of Algeciras", type: "sea" },
    { code: "BIL", name: "Bilbao", type: "sea" },
    { code: "LPA", name: "Las Palmas", type: "sea" },
    { code: "SCT", name: "Santa Cruz de Tenerife", type: "sea" },
    { code: "VIG", name: "Vigo", type: "sea" },
    { code: "TAR", name: "Tarragona", type: "sea" },
    { code: "CAR", name: "Cartagena", type: "sea" },
    { code: "SEV", name: "Seville", type: "sea" }
  ],

  // ============================================
  // EUROPE - EASTERN & BALKANS
  // ============================================
  "Albania": [
    { code: "TIA", name: "Tirana International Airport", type: "air" },
    { code: "DUR", name: "Durrës Port", type: "sea" },
    { code: "VLO", name: "Vlorë", type: "sea" },
    { code: "SHG", name: "Shëngjin", type: "sea" },
    { code: "SAR", name: "Sarandë", type: "sea" }
  ],
  "Azerbaijan": [
    { code: "GYD", name: "Baku Heydar Aliyev Airport", type: "air" },
    { code: "BAK", name: "Baku Port", type: "sea" }
  ],
  "Belarus": [
    { code: "MSQ", name: "Minsk National Airport", type: "air" }
  ],
  "Bosnia and Herzegovina": [
    { code: "SJJ", name: "Sarajevo International Airport", type: "air" }
  ],
  "Bulgaria": [
    { code: "SOF", name: "Sofia Airport", type: "air" },
    { code: "VAR", name: "Varna Airport", type: "air" },
    { code: "VAN", name: "Port of Varna", type: "sea" },
    { code: "BOU", name: "Port of Bourgas", type: "sea" },
    { code: "BAL", name: "Balchik", type: "sea" }
  ],
  "Croatia": [
    { code: "ZAG", name: "Zagreb Airport", type: "air" },
    { code: "DBV", name: "Dubrovnik Airport", type: "air" },
    { code: "SPU", name: "Split Airport", type: "air" },
    { code: "RJK", name: "Port of Rijeka", type: "sea" },
    { code: "SPL", name: "Port of Split", type: "sea" },
    { code: "PLO", name: "Port of Ploče", type: "sea" },
    { code: "ZAD", name: "Port of Zadar", type: "sea" },
    { code: "SIB", name: "Port of Šibenik", type: "sea" },
    { code: "DUB", name: "Port of Dubrovnik", type: "sea" },
    { code: "PUL", name: "Port of Pula", type: "sea" }
  ],
  "Czech Republic": [
    { code: "PRG", name: "Prague Václav Havel Airport", type: "air" }
  ],
  "Georgia": [
    { code: "TBS", name: "Tbilisi International Airport", type: "air" },
    { code: "BUS", name: "Batumi International Airport", type: "air" },
    { code: "BAT", name: "Port of Batumi", type: "sea" },
    { code: "POT", name: "Port of Poti", type: "sea" }
  ],
  "Hungary": [
    { code: "BUD", name: "Budapest Ferenc Liszt Airport", type: "air" }
  ],
  "Kazakhstan": [
    { code: "ALA", name: "Almaty International Airport", type: "air" },
    { code: "NQZ", name: "Astana Nursultan Nazarbayev Airport", type: "air" },
    { code: "AKT", name: "Port of Aktau", type: "sea" }
  ],
  "Kosovo": [
    { code: "PRN", name: "Pristina International Airport", type: "air" }
  ],
  "Moldova": [
    { code: "KIV", name: "Chișinău International Airport", type: "air" }
  ],
  "Montenegro": [
    { code: "TGD", name: "Podgorica Airport", type: "air" },
    { code: "TIV", name: "Tivat Airport", type: "air" },
    { code: "BAR", name: "Port of Bar", type: "sea" }
  ],
  "North Macedonia": [
    { code: "SKP", name: "Skopje International Airport", type: "air" }
  ],
  "Romania": [
    { code: "OTP", name: "Bucharest Henri Coandă Airport", type: "air" },
    { code: "CLJ", name: "Cluj-Napoca Airport", type: "air" },
    { code: "CND", name: "Port of Constanța", type: "sea" },
    { code: "MID", name: "Port of Midia", type: "sea" },
    { code: "MAN", name: "Port of Mangalia", type: "sea" },
    { code: "SUL", name: "Port of Sulina", type: "sea" },
    { code: "GAL", name: "Port of Galați", type: "sea" },
    { code: "TUL", name: "Port of Tulcea", type: "sea" }
  ],
  "Serbia": [
    { code: "BEG", name: "Belgrade Nikola Tesla Airport", type: "air" }
  ],
  "Slovakia": [
    { code: "BTS", name: "Bratislava Airport", type: "air" }
  ],
  "Slovenia": [
    { code: "LJU", name: "Ljubljana Jože Pučnik Airport", type: "air" },
    { code: "KOP", name: "Port of Koper", type: "sea" }
  ],
  "Turkmenistan": [
    { code: "ASB", name: "Ashgabat International Airport", type: "air" },
    { code: "TKM", name: "Port of Turkmenbashi", type: "sea" }
  ],
  "Uzbekistan": [
    { code: "TAS", name: "Tashkent International Airport", type: "air" }
  ],

  // ============================================
  // EUROPE - NORTHERN
  // ============================================
  "Denmark": [
    { code: "CPH", name: "Copenhagen Airport", type: "air" },
    { code: "AAL", name: "Aalborg Airport", type: "air" },
    { code: "CPP", name: "Copenhagen Port", type: "sea" },
    { code: "AAR", name: "Aarhus", type: "sea" }
  ],
  "Estonia": [
    { code: "TLL", name: "Tallinn Airport", type: "air" },
    { code: "TAL", name: "Tallinn Port", type: "sea" }
  ],
  "Finland": [
    { code: "HEL", name: "Helsinki Airport", type: "air" },
    { code: "HEP", name: "Helsinki Port", type: "sea" },
    { code: "KOT", name: "Kotka", type: "sea" },
    { code: "HAM", name: "Hamina", type: "sea" }
  ],
  "Iceland": [
    { code: "KEF", name: "Keflavík International Airport", type: "air" },
    { code: "REY", name: "Reykjavík Port", type: "sea" }
  ],
  "Latvia": [
    { code: "RIX", name: "Riga International Airport", type: "air" },
    { code: "RIG", name: "Riga Port", type: "sea" },
    { code: "VEN", name: "Ventspils", type: "sea" },
    { code: "LIE", name: "Liepāja", type: "sea" }
  ],
  "Lithuania": [
    { code: "VNO", name: "Vilnius International Airport", type: "air" },
    { code: "KLP", name: "Klaipėda", type: "sea" }
  ],
  "Norway": [
    { code: "OSL", name: "Oslo Gardermoen Airport", type: "air" },
    { code: "BGO", name: "Bergen Airport", type: "air" },
    { code: "TRD", name: "Trondheim Airport", type: "air" },
    { code: "OSP", name: "Oslo Port", type: "sea" },
    { code: "BER", name: "Bergen Port", type: "sea" },
    { code: "STA", name: "Stavanger", type: "sea" }
  ],
  "Poland": [
    { code: "WAW", name: "Warsaw Chopin Airport", type: "air" },
    { code: "KRK", name: "Kraków Airport", type: "air" },
    { code: "GDN", name: "Gdańsk Airport", type: "air" },
    { code: "GDA", name: "Port of Gdańsk", type: "sea" },
    { code: "GDY", name: "Port of Gdynia", type: "sea" },
    { code: "SWI", name: "Szczecin-Świnoujście", type: "sea" }
  ],
  "Russia": [
    { code: "SVO", name: "Moscow Sheremetyevo Airport", type: "air" },
    { code: "DME", name: "Moscow Domodedovo Airport", type: "air" },
    { code: "LED", name: "St. Petersburg Pulkovo Airport", type: "air" },
    { code: "VVO", name: "Vladivostok Airport", type: "air" },
    { code: "STP", name: "St. Petersburg Port", type: "sea" },
    { code: "NVO", name: "Novorossiysk", type: "sea" },
    { code: "UST", name: "Ust-Luga", type: "sea" },
    { code: "VLA", name: "Vladivostok Port", type: "sea" },
    { code: "KAL", name: "Kaliningrad", type: "sea" },
    { code: "MUR", name: "Murmansk", type: "sea" },
    { code: "NAK", name: "Nakhodka", type: "sea" },
    { code: "VOS", name: "Vostochny", type: "sea" }
  ],
  "Sweden": [
    { code: "ARN", name: "Stockholm Arlanda Airport", type: "air" },
    { code: "GOT", name: "Gothenburg Landvetter Airport", type: "air" },
    { code: "GBG", name: "Port of Gothenburg", type: "sea" },
    { code: "STO", name: "Stockholm Port", type: "sea" },
    { code: "MAL", name: "Malmö Port", type: "sea" },
    { code: "HEL", name: "Helsingborg", type: "sea" }
  ],
  "Ukraine": [
    { code: "KBP", name: "Kyiv Boryspil Airport", type: "air" },
    { code: "ODS", name: "Odessa Airport", type: "air" },
    { code: "ODE", name: "Odessa Port", type: "sea" },
    { code: "YUZ", name: "Yuzhny", type: "sea" },
    { code: "CHO", name: "Chornomorsk", type: "sea" }
  ],

  // ============================================
  // TURKEY
  // ============================================
  "Turkey": [
    { code: "IST", name: "Istanbul Airport", type: "air" },
    { code: "SAW", name: "Istanbul Sabiha Gökçen Airport", type: "air" },
    { code: "ESB", name: "Ankara Esenboğa Airport", type: "air" },
    { code: "AYT", name: "Antalya Airport", type: "air" },
    { code: "ADB", name: "Izmir Adnan Menderes Airport", type: "air" },
    { code: "AMB", name: "Ambarlı (Istanbul)", type: "sea" },
    { code: "MER", name: "Mersin", type: "sea" },
    { code: "IZM", name: "Izmir (Alsancak)", type: "sea" },
    { code: "ISK", name: "Iskenderun", type: "sea" },
    { code: "ASY", name: "Asyaport (Tekirdağ)", type: "sea" },
    { code: "GEM", name: "Gemlik", type: "sea" },
    { code: "ALI", name: "Aliağa", type: "sea" },
    { code: "HAY", name: "Haydarpaşa", type: "sea" },
    { code: "SAM", name: "Samsun", type: "sea" },
    { code: "TRA", name: "Trabzon", type: "sea" },
    { code: "ANT", name: "Antalya Port", type: "sea" }
  ],

  // ============================================
  // MIDDLE EAST
  // ============================================
  "Bahrain": [
    { code: "BAH", name: "Bahrain International Airport", type: "air" },
    { code: "KBS", name: "Khalifa Bin Salman Port", type: "sea" }
  ],
  "Iran": [
    { code: "IKA", name: "Tehran Imam Khomeini Airport", type: "air" },
    { code: "BND", name: "Bandar Abbas", type: "sea" },
    { code: "BIK", name: "Bandar Imam Khomeini", type: "sea" },
    { code: "BUS", name: "Bushehr", type: "sea" },
    { code: "KHO", name: "Khorramshahr", type: "sea" }
  ],
  "Iraq": [
    { code: "BGW", name: "Baghdad International Airport", type: "air" },
    { code: "BSR", name: "Basra Airport", type: "air" },
    { code: "UMQ", name: "Umm Qasr", type: "sea" }
  ],
  "Israel": [
    { code: "TLV", name: "Ben Gurion Airport", type: "air" },
    { code: "ASH", name: "Ashdod", type: "sea" },
    { code: "HAI", name: "Haifa", type: "sea" },
    { code: "EIL", name: "Eilat", type: "sea" }
  ],
  "Jordan": [
    { code: "AMM", name: "Queen Alia International Airport", type: "air" },
    { code: "AQA", name: "Aqaba", type: "sea" }
  ],
  "Kuwait": [
    { code: "KWI", name: "Kuwait International Airport", type: "air" },
    { code: "SHU", name: "Shuwaikh", type: "sea" },
    { code: "SHA", name: "Shuaiba", type: "sea" }
  ],
  "Lebanon": [
    { code: "BEY", name: "Beirut–Rafic Hariri International Airport", type: "air" },
    { code: "BEI", name: "Beirut Port", type: "sea" },
    { code: "TRI", name: "Tripoli Port", type: "sea" }
  ],
  "Oman": [
    { code: "MCT", name: "Muscat International Airport", type: "air" },
    { code: "SLL", name: "Salalah Airport", type: "air" },
    { code: "SOH", name: "Sohar Port", type: "sea" },
    { code: "SAL", name: "Salalah Port", type: "sea" },
    { code: "MUS", name: "Muscat (Sultan Qaboos)", type: "sea" }
  ],
  "Qatar": [
    { code: "DOH", name: "Hamad International Airport", type: "air" },
    { code: "HMD", name: "Hamad Port", type: "sea" },
    { code: "RAS", name: "Ras Laffan", type: "sea" }
  ],
  "Saudi Arabia": [
    { code: "RUH", name: "King Khalid International Airport", type: "air" },
    { code: "JED", name: "King Abdulaziz International Airport", type: "air" },
    { code: "DMM", name: "King Fahd International Airport", type: "air" },
    { code: "JEP", name: "Jeddah Islamic Port", type: "sea" },
    { code: "DMM", name: "Dammam (King Abdul Aziz)", type: "sea" },
    { code: "JUB", name: "Jubail", type: "sea" },
    { code: "YAN", name: "Yanbu", type: "sea" }
  ],
  "United Arab Emirates": [
    { code: "DXB", name: "Dubai International Airport", type: "air" },
    { code: "AUH", name: "Abu Dhabi International Airport", type: "air" },
    { code: "SHJ", name: "Sharjah International Airport", type: "air" },
    { code: "JEA", name: "Jebel Ali Port", type: "sea" },
    { code: "DUB", name: "Port Rashid (Dubai)", type: "sea" },
    { code: "KHF", name: "Khalifa Port (Abu Dhabi)", type: "sea" },
    { code: "SHR", name: "Sharjah Port", type: "sea" },
    { code: "FUJ", name: "Fujairah", type: "sea" }
  ],
  "Yemen": [
    { code: "ADE", name: "Aden International Airport", type: "air" },
    { code: "ADP", name: "Aden Port", type: "sea" },
    { code: "HOD", name: "Hodeidah", type: "sea" }
  ],

  // ============================================
  // ASIA - EAST
  // ============================================
  "China": [
    { code: "PVG", name: "Shanghai Pudong International Airport", type: "air" },
    { code: "PEK", name: "Beijing Capital International Airport", type: "air" },
    { code: "PKX", name: "Beijing Daxing International Airport", type: "air" },
    { code: "CAN", name: "Guangzhou Baiyun International Airport", type: "air" },
    { code: "HKG", name: "Hong Kong International Airport", type: "air" },
    { code: "SZX", name: "Shenzhen Bao'an International Airport", type: "air" },
    { code: "CTU", name: "Chengdu Tianfu International Airport", type: "air" },
    { code: "KMG", name: "Kunming Changshui International Airport", type: "air" },
    { code: "XMN", name: "Xiamen Gaoqi International Airport", type: "air" },
    { code: "SHA", name: "Port of Shanghai", type: "sea" },
    { code: "NGB", name: "Port of Ningbo-Zhoushan", type: "sea" },
    { code: "SZP", name: "Port of Shenzhen", type: "sea" },
    { code: "GZP", name: "Port of Guangzhou", type: "sea" },
    { code: "QIN", name: "Port of Qingdao", type: "sea" },
    { code: "TIA", name: "Port of Tianjin", type: "sea" },
    { code: "XIA", name: "Port of Xiamen", type: "sea" },
    { code: "DLC", name: "Dalian", type: "sea" },
    { code: "YTN", name: "Yantian", type: "sea" },
    { code: "HGK", name: "Hong Kong Port", type: "sea" },
    { code: "LYG", name: "Lianyungang", type: "sea" },
    { code: "NJP", name: "Nanjing", type: "sea" },
    { code: "FZH", name: "Fuzhou", type: "sea" }
  ],
  "Hong Kong": [
    { code: "HKG", name: "Hong Kong International Airport", type: "air" },
    { code: "HKP", name: "Hong Kong Port (Kwai Tsing)", type: "sea" }
  ],
  "Japan": [
    { code: "NRT", name: "Narita International Airport", type: "air" },
    { code: "HND", name: "Tokyo Haneda Airport", type: "air" },
    { code: "KIX", name: "Kansai International Airport", type: "air" },
    { code: "NGO", name: "Chubu Centrair International Airport", type: "air" },
    { code: "FUK", name: "Fukuoka Airport", type: "air" },
    { code: "CTS", name: "New Chitose Airport", type: "air" },
    { code: "TOK", name: "Port of Tokyo", type: "sea" },
    { code: "YOK", name: "Port of Yokohama", type: "sea" },
    { code: "KOB", name: "Port of Kobe", type: "sea" },
    { code: "NAG", name: "Port of Nagoya", type: "sea" },
    { code: "OSA", name: "Port of Osaka", type: "sea" },
    { code: "HAK", name: "Hakata (Fukuoka)", type: "sea" },
    { code: "CHB", name: "Chiba", type: "sea" }
  ],
  "Macau": [
    { code: "MFM", name: "Macau International Airport", type: "air" }
  ],
  "Mongolia": [
    { code: "ULN", name: "Chinggis Khaan International Airport", type: "air" }
  ],
  "North Korea": [
    { code: "FNJ", name: "Pyongyang Sunan International Airport", type: "air" },
    { code: "NAM", name: "Nampo", type: "sea" }
  ],
  "South Korea": [
    { code: "ICN", name: "Incheon International Airport", type: "air" },
    { code: "GMP", name: "Seoul Gimpo Airport", type: "air" },
    { code: "PUS", name: "Busan Gimhae Airport", type: "air" },
    { code: "BSP", name: "Busan Port", type: "sea" },
    { code: "INC", name: "Incheon Port", type: "sea" },
    { code: "GWA", name: "Gwangyang", type: "sea" },
    { code: "ULS", name: "Ulsan", type: "sea" }
  ],
  "Taiwan": [
    { code: "TPE", name: "Taiwan Taoyuan International Airport", type: "air" },
    { code: "KHH", name: "Kaohsiung Airport", type: "air" },
    { code: "KHP", name: "Kaohsiung Port", type: "sea" },
    { code: "KEE", name: "Keelung Port", type: "sea" },
    { code: "TXG", name: "Taichung Port", type: "sea" }
  ],

  // ============================================
  // ASIA - SOUTHEAST
  // ============================================
  "Brunei": [
    { code: "BWN", name: "Brunei International Airport", type: "air" },
    { code: "MUA", name: "Muara Port", type: "sea" }
  ],
  "Cambodia": [
    { code: "PNH", name: "Phnom Penh International Airport", type: "air" },
    { code: "REP", name: "Siem Reap International Airport", type: "air" },
    { code: "SHV", name: "Sihanoukville Port", type: "sea" },
    { code: "PNP", name: "Phnom Penh Port", type: "sea" }
  ],
  "Indonesia": [
    { code: "CGK", name: "Jakarta Soekarno-Hatta Airport", type: "air" },
    { code: "SUB", name: "Surabaya Juanda Airport", type: "air" },
    { code: "DPS", name: "Bali Ngurah Rai Airport", type: "air" },
    { code: "UPG", name: "Makassar Hasanuddin Airport", type: "air" },
    { code: "MES", name: "Medan Kualanamu Airport", type: "air" },
    { code: "TJP", name: "Tanjung Priok (Jakarta)", type: "sea" },
    { code: "SUR", name: "Surabaya (Tanjung Perak)", type: "sea" },
    { code: "SEM", name: "Semarang", type: "sea" },
    { code: "BEL", name: "Belawan (Medan)", type: "sea" },
    { code: "MAK", name: "Makassar", type: "sea" },
    { code: "BAL", name: "Balikpapan", type: "sea" },
    { code: "PAL", name: "Palembang", type: "sea" },
    { code: "BAT", name: "Batam", type: "sea" }
  ],
  "Laos": [
    { code: "VTE", name: "Vientiane Wattay Airport", type: "air" },
    { code: "LPQ", name: "Luang Prabang Airport", type: "air" }
  ],
  "Malaysia": [
    { code: "KUL", name: "Kuala Lumpur International Airport", type: "air" },
    { code: "PEN", name: "Penang International Airport", type: "air" },
    { code: "LGK", name: "Langkawi International Airport", type: "air" },
    { code: "KCH", name: "Kuching International Airport", type: "air" },
    { code: "BKI", name: "Kota Kinabalu International Airport", type: "air" },
    { code: "PKL", name: "Port Klang", type: "sea" },
    { code: "TPP", name: "Tanjung Pelepas", type: "sea" },
    { code: "PNG", name: "Penang Port", type: "sea" },
    { code: "PGU", name: "Pasir Gudang (Johor)", type: "sea" },
    { code: "KCH", name: "Kuching Port", type: "sea" },
    { code: "KKP", name: "Kota Kinabalu Port", type: "sea" },
    { code: "BIN", name: "Bintulu", type: "sea" }
  ],
  "Myanmar": [
    { code: "RGN", name: "Yangon International Airport", type: "air" },
    { code: "MDL", name: "Mandalay International Airport", type: "air" },
    { code: "YGN", name: "Yangon Port", type: "sea" }
  ],
  "Philippines": [
    { code: "MNL", name: "Manila Ninoy Aquino Airport", type: "air" },
    { code: "CEB", name: "Cebu Mactan International Airport", type: "air" },
    { code: "DVO", name: "Davao Francisco Bangoy Airport", type: "air" },
    { code: "CRK", name: "Clark International Airport", type: "air" },
    { code: "MNP", name: "Manila Port", type: "sea" },
    { code: "CEP", name: "Cebu Port", type: "sea" },
    { code: "DVP", name: "Davao Port", type: "sea" },
    { code: "SUB", name: "Subic Bay", type: "sea" },
    { code: "BAT", name: "Batangas Port", type: "sea" }
  ],
  "Singapore": [
    { code: "SIN", name: "Singapore Changi Airport", type: "air" },
    { code: "SGP", name: "Port of Singapore", type: "sea" },
    { code: "JUR", name: "Jurong Port", type: "sea" }
  ],
  "Thailand": [
    { code: "BKK", name: "Bangkok Suvarnabhumi Airport", type: "air" },
    { code: "DMK", name: "Bangkok Don Mueang Airport", type: "air" },
    { code: "HKT", name: "Phuket International Airport", type: "air" },
    { code: "CNX", name: "Chiang Mai International Airport", type: "air" },
    { code: "LCB", name: "Laem Chabang", type: "sea" },
    { code: "BKP", name: "Bangkok Port (Klong Toey)", type: "sea" },
    { code: "MAP", name: "Map Ta Phut", type: "sea" },
    { code: "SON", name: "Songkhla", type: "sea" }
  ],
  "Timor-Leste": [
    { code: "DIL", name: "Dili Presidente Nicolau Lobato Airport", type: "air" },
    { code: "DIP", name: "Dili Port", type: "sea" }
  ],
  "Vietnam": [
    { code: "SGN", name: "Ho Chi Minh City Tan Son Nhat Airport", type: "air" },
    { code: "HAN", name: "Hanoi Noi Bai Airport", type: "air" },
    { code: "DAD", name: "Da Nang International Airport", type: "air" },
    { code: "CXR", name: "Cam Ranh Airport", type: "air" },
    { code: "HCM", name: "Ho Chi Minh City (Cat Lai)", type: "sea" },
    { code: "HAI", name: "Hai Phong", type: "sea" },
    { code: "CMT", name: "Cai Mep-Thi Vai", type: "sea" },
    { code: "DAN", name: "Da Nang Port", type: "sea" },
    { code: "QNH", name: "Quy Nhon", type: "sea" },
    { code: "VUT", name: "Vung Tau", type: "sea" }
  ],

  // ============================================
  // ASIA - SOUTH
  // ============================================
  "Bangladesh": [
    { code: "DAC", name: "Dhaka Hazrat Shahjalal Airport", type: "air" },
    { code: "CGP", name: "Chittagong Shah Amanat Airport", type: "air" },
    { code: "CHT", name: "Chittagong Port", type: "sea" },
    { code: "MON", name: "Mongla", type: "sea" }
  ],
  "India": [
    { code: "DEL", name: "Delhi Indira Gandhi International Airport", type: "air" },
    { code: "BOM", name: "Mumbai Chhatrapati Shivaji Airport", type: "air" },
    { code: "MAA", name: "Chennai International Airport", type: "air" },
    { code: "BLR", name: "Bangalore Kempegowda Airport", type: "air" },
    { code: "HYD", name: "Hyderabad Rajiv Gandhi Airport", type: "air" },
    { code: "CCU", name: "Kolkata Netaji Subhas Chandra Bose Airport", type: "air" },
    { code: "COK", name: "Cochin International Airport", type: "air" },
    { code: "GOI", name: "Goa International Airport", type: "air" },
    { code: "JNP", name: "Jawaharlal Nehru Port (JNPT)", type: "sea" },
    { code: "MUM", name: "Mumbai Port", type: "sea" },
    { code: "CHE", name: "Chennai Port", type: "sea" },
    { code: "KOL", name: "Kolkata Port (Haldia)", type: "sea" },
    { code: "MUN", name: "Mundra Port", type: "sea" },
    { code: "KAN", name: "Kandla (Deendayal)", type: "sea" },
    { code: "VIZ", name: "Visakhapatnam", type: "sea" },
    { code: "COC", name: "Cochin Port", type: "sea" },
    { code: "TUT", name: "Tuticorin (V.O. Chidambaranar)", type: "sea" },
    { code: "MOR", name: "Mormugao", type: "sea" },
    { code: "MAN", name: "New Mangalore", type: "sea" },
    { code: "PAR", name: "Paradip", type: "sea" },
    { code: "ENN", name: "Ennore (Kamarajar)", type: "sea" }
  ],
  "Maldives": [
    { code: "MLE", name: "Malé Velana International Airport", type: "air" },
    { code: "MAP", name: "Malé Commercial Port", type: "sea" }
  ],
  "Nepal": [
    { code: "KTM", name: "Kathmandu Tribhuvan Airport", type: "air" }
  ],
  "Pakistan": [
    { code: "KHI", name: "Karachi Jinnah International Airport", type: "air" },
    { code: "LHE", name: "Lahore Allama Iqbal Airport", type: "air" },
    { code: "ISB", name: "Islamabad International Airport", type: "air" },
    { code: "KPT", name: "Karachi Port", type: "sea" },
    { code: "PQM", name: "Port Qasim", type: "sea" },
    { code: "GWD", name: "Gwadar", type: "sea" }
  ],
  "Sri Lanka": [
    { code: "CMB", name: "Colombo Bandaranaike Airport", type: "air" },
    { code: "CMP", name: "Colombo Port", type: "sea" },
    { code: "HAM", name: "Hambantota", type: "sea" }
  ],

  // ============================================
  // AFRICA - NORTH
  // ============================================
  "Algeria": [
    { code: "ALG", name: "Algiers Houari Boumediene Airport", type: "air" },
    { code: "ORN", name: "Oran Es Sénia Airport", type: "air" },
    { code: "ALP", name: "Algiers Port", type: "sea" },
    { code: "ORP", name: "Oran Port", type: "sea" },
    { code: "BJA", name: "Béjaïa", type: "sea" },
    { code: "SKI", name: "Skikda", type: "sea" }
  ],
  "Egypt": [
    { code: "CAI", name: "Cairo International Airport", type: "air" },
    { code: "HRG", name: "Hurghada International Airport", type: "air" },
    { code: "SSH", name: "Sharm El Sheikh International Airport", type: "air" },
    { code: "ALY", name: "Alexandria (El Nozha Airport)", type: "air" },
    { code: "ALE", name: "Port of Alexandria", type: "sea" },
    { code: "PSD", name: "Port Said", type: "sea" },
    { code: "DAM", name: "Damietta", type: "sea" },
    { code: "SOK", name: "Sokhna (Ain Sukhna)", type: "sea" },
    { code: "SUZ", name: "Suez (Port Tawfiq)", type: "sea" },
    { code: "DEK", name: "Dekheila", type: "sea" }
  ],
  "Libya": [
    { code: "TIP", name: "Tripoli International Airport", type: "air" },
    { code: "BEN", name: "Benghazi Benina Airport", type: "air" },
    { code: "TRP", name: "Tripoli Port", type: "sea" },
    { code: "BNP", name: "Benghazi Port", type: "sea" }
  ],
  "Morocco": [
    { code: "CMN", name: "Casablanca Mohammed V Airport", type: "air" },
    { code: "RAK", name: "Marrakech Menara Airport", type: "air" },
    { code: "TNG", name: "Tangier Ibn Battouta Airport", type: "air" },
    { code: "TNM", name: "Tanger Med", type: "sea" },
    { code: "CAS", name: "Casablanca Port", type: "sea" },
    { code: "JOR", name: "Jorf Lasfar", type: "sea" },
    { code: "AGD", name: "Agadir", type: "sea" },
    { code: "TAN", name: "Tangier Port", type: "sea" }
  ],
  "Tunisia": [
    { code: "TUN", name: "Tunis-Carthage Airport", type: "air" },
    { code: "TUP", name: "Tunis (La Goulette)", type: "sea" },
    { code: "SFA", name: "Sfax", type: "sea" },
    { code: "RAD", name: "Radès", type: "sea" }
  ],

  // ============================================
  // AFRICA - WEST
  // ============================================
  "Benin": [
    { code: "COO", name: "Cotonou Cadjehoun Airport", type: "air" },
    { code: "COT", name: "Port of Cotonou", type: "sea" }
  ],
  "Burkina Faso": [
    { code: "OUA", name: "Ouagadougou Airport", type: "air" }
  ],
  "Cameroon": [
    { code: "DLA", name: "Douala International Airport", type: "air" },
    { code: "DOU", name: "Douala Port", type: "sea" },
    { code: "KRI", name: "Kribi Deep Sea Port", type: "sea" }
  ],
  "Côte d'Ivoire": [
    { code: "ABJ", name: "Abidjan Félix Houphouët-Boigny Airport", type: "air" },
    { code: "ABP", name: "Abidjan Port", type: "sea" },
    { code: "SPE", name: "San Pedro", type: "sea" }
  ],
  "Ghana": [
    { code: "ACC", name: "Accra Kotoka International Airport", type: "air" },
    { code: "TEM", name: "Tema Port", type: "sea" },
    { code: "TAK", name: "Takoradi", type: "sea" }
  ],
  "Nigeria": [
    { code: "LOS", name: "Lagos Murtala Muhammed Airport", type: "air" },
    { code: "ABV", name: "Abuja Nnamdi Azikiwe Airport", type: "air" },
    { code: "PHC", name: "Port Harcourt Airport", type: "air" },
    { code: "APA", name: "Apapa (Lagos)", type: "sea" },
    { code: "TIN", name: "Tin Can Island (Lagos)", type: "sea" },
    { code: "PHC", name: "Port Harcourt", type: "sea" },
    { code: "ONN", name: "Onne", type: "sea" },
    { code: "CAL", name: "Calabar", type: "sea" }
  ],
  "Senegal": [
    { code: "DSS", name: "Dakar Blaise Diagne Airport", type: "air" },
    { code: "DKR", name: "Dakar Port", type: "sea" }
  ],
  "Togo": [
    { code: "LFW", name: "Lomé-Tokoin Airport", type: "air" },
    { code: "LOM", name: "Lomé Port", type: "sea" }
  ],
  "Cape Verde": [
    { code: "SID", name: "Amílcar Cabral International Airport", type: "air" },
    { code: "PRA", name: "Praia Nelson Mandela Airport", type: "air" },
    { code: "PRP", name: "Port of Praia", type: "sea" },
    { code: "MIN", name: "Port of Mindelo", type: "sea" }
  ],
  "Gambia": [
    { code: "BJL", name: "Banjul International Airport", type: "air" },
    { code: "BAN", name: "Port of Banjul", type: "sea" }
  ],
  "Guinea": [
    { code: "CKY", name: "Conakry International Airport", type: "air" },
    { code: "CNK", name: "Port of Conakry", type: "sea" }
  ],
  "Guinea-Bissau": [
    { code: "OXB", name: "Osvaldo Vieira International Airport", type: "air" },
    { code: "BIS", name: "Port of Bissau", type: "sea" }
  ],
  "Liberia": [
    { code: "ROB", name: "Roberts International Airport", type: "air" },
    { code: "MLW", name: "Port of Monrovia", type: "sea" },
    { code: "BUC", name: "Port of Buchanan", type: "sea" }
  ],
  "Mali": [
    { code: "BKO", name: "Bamako-Sénou International Airport", type: "air" }
  ],
  "Mauritania": [
    { code: "NKC", name: "Nouakchott-Oumtounsy Airport", type: "air" },
    { code: "NOU", name: "Port of Nouakchott", type: "sea" },
    { code: "NDB", name: "Port of Nouadhibou", type: "sea" }
  ],
  "Niger": [
    { code: "NIM", name: "Diori Hamani International Airport", type: "air" }
  ],
  "Sierra Leone": [
    { code: "FNA", name: "Lungi International Airport", type: "air" },
    { code: "FRE", name: "Port of Freetown", type: "sea" }
  ],
  "Equatorial Guinea": [
    { code: "SSG", name: "Malabo Airport", type: "air" },
    { code: "BSG", name: "Bata Airport", type: "air" },
    { code: "MAL", name: "Port of Malabo", type: "sea" },
    { code: "BTP", name: "Port of Bata", type: "sea" }
  ],
  "Gabon": [
    { code: "LBV", name: "Libreville Leon M'ba Airport", type: "air" },
    { code: "POG", name: "Port-Gentil Airport", type: "air" },
    { code: "LIB", name: "Port of Libreville (Owendo)", type: "sea" },
    { code: "PGT", name: "Port of Port-Gentil", type: "sea" }
  ],
  "Republic of the Congo": [
    { code: "BZV", name: "Brazzaville Maya-Maya Airport", type: "air" },
    { code: "PNR", name: "Pointe-Noire Airport", type: "air" },
    { code: "PNP", name: "Port of Pointe-Noire", type: "sea" }
  ],
  "Democratic Republic of the Congo": [
    { code: "FIH", name: "Kinshasa N'djili Airport", type: "air" },
    { code: "MAT", name: "Matadi Port", type: "sea" },
    { code: "BOA", name: "Boma Port", type: "sea" }
  ],
  "São Tomé and Príncipe": [
    { code: "TMS", name: "São Tomé International Airport", type: "air" },
    { code: "STP", name: "Port of São Tomé", type: "sea" }
  ],

  // ============================================
  // AFRICA - EAST
  // ============================================
  "Djibouti": [
    { code: "JIB", name: "Djibouti-Ambouli Airport", type: "air" },
    { code: "DJI", name: "Djibouti Port", type: "sea" },
    { code: "DOR", name: "Doraleh", type: "sea" }
  ],
  "Ethiopia": [
    { code: "ADD", name: "Addis Ababa Bole Airport", type: "air" }
  ],
  "Kenya": [
    { code: "NBO", name: "Nairobi Jomo Kenyatta Airport", type: "air" },
    { code: "MBA", name: "Mombasa Moi International Airport", type: "air" },
    { code: "MOM", name: "Mombasa Port", type: "sea" }
  ],
  "Madagascar": [
    { code: "TNR", name: "Antananarivo Ivato Airport", type: "air" },
    { code: "TOA", name: "Toamasina Port", type: "sea" }
  ],
  "Mauritius": [
    { code: "MRU", name: "Mauritius Sir Seewoosagur Airport", type: "air" },
    { code: "PLO", name: "Port Louis", type: "sea" }
  ],
  "Mozambique": [
    { code: "MPM", name: "Maputo International Airport", type: "air" },
    { code: "MAP", name: "Maputo Port", type: "sea" },
    { code: "BEI", name: "Beira", type: "sea" },
    { code: "NAC", name: "Nacala", type: "sea" }
  ],
  "Réunion": [
    { code: "RUN", name: "Roland Garros Airport", type: "air" },
    { code: "POR", name: "Port Réunion", type: "sea" }
  ],
  "Tanzania": [
    { code: "DAR", name: "Dar es Salaam Julius Nyerere Airport", type: "air" },
    { code: "ZNZ", name: "Zanzibar Abeid Amani Karume Airport", type: "air" },
    { code: "DSM", name: "Dar es Salaam Port", type: "sea" },
    { code: "TAN", name: "Tanga", type: "sea" },
    { code: "MTW", name: "Mtwara", type: "sea" }
  ],
  "Comoros": [
    { code: "HAH", name: "Prince Said Ibrahim Airport", type: "air" },
    { code: "MOR", name: "Port of Moroni", type: "sea" }
  ],
  "Eritrea": [
    { code: "ASM", name: "Asmara International Airport", type: "air" },
    { code: "MSW", name: "Port of Massawa", type: "sea" },
    { code: "ASB", name: "Port of Assab", type: "sea" }
  ],
  "Rwanda": [
    { code: "KGL", name: "Kigali International Airport", type: "air" }
  ],
  "Seychelles": [
    { code: "SEZ", name: "Seychelles International Airport", type: "air" },
    { code: "VIC", name: "Port Victoria", type: "sea" }
  ],
  "Somalia": [
    { code: "MGQ", name: "Mogadishu Aden Adde Airport", type: "air" },
    { code: "MOG", name: "Port of Mogadishu", type: "sea" },
    { code: "BER", name: "Port of Berbera", type: "sea" },
    { code: "KIS", name: "Port of Kismayo", type: "sea" },
    { code: "BOS", name: "Port of Bosaso", type: "sea" }
  ],
  "South Sudan": [
    { code: "JUB", name: "Juba International Airport", type: "air" }
  ],
  "Sudan": [
    { code: "KRT", name: "Khartoum International Airport", type: "air" },
    { code: "PZU", name: "Port Sudan Airport", type: "air" },
    { code: "PSD", name: "Port Sudan", type: "sea" }
  ],
  "Uganda": [
    { code: "EBB", name: "Entebbe International Airport", type: "air" }
  ],

  // ============================================
  // AFRICA - SOUTH
  // ============================================
  "Angola": [
    { code: "LAD", name: "Luanda Quatro de Fevereiro Airport", type: "air" },
    { code: "LUA", name: "Luanda Port", type: "sea" },
    { code: "LOB", name: "Lobito", type: "sea" }
  ],
  "Namibia": [
    { code: "WDH", name: "Windhoek Hosea Kutako Airport", type: "air" },
    { code: "WAL", name: "Walvis Bay", type: "sea" }
  ],
  "South Africa": [
    { code: "JNB", name: "Johannesburg O.R. Tambo Airport", type: "air" },
    { code: "CPT", name: "Cape Town International Airport", type: "air" },
    { code: "DUR", name: "Durban King Shaka Airport", type: "air" },
    { code: "DUR", name: "Durban Port", type: "sea" },
    { code: "RIC", name: "Richards Bay", type: "sea" },
    { code: "CPT", name: "Cape Town Port", type: "sea" },
    { code: "NGQ", name: "Ngqura (Coega)", type: "sea" },
    { code: "PEL", name: "Port Elizabeth", type: "sea" },
    { code: "SAL", name: "Saldanha Bay", type: "sea" },
    { code: "EAS", name: "East London", type: "sea" }
  ],
  "Botswana": [
    { code: "GBE", name: "Sir Seretse Khama Airport", type: "air" }
  ],
  "Eswatini": [
    { code: "SHO", name: "King Mswati III International Airport", type: "air" }
  ],
  "Lesotho": [
    { code: "MSU", name: "Moshoeshoe I International Airport", type: "air" }
  ],
  "Malawi": [
    { code: "LLW", name: "Lilongwe Kamuzu International Airport", type: "air" },
    { code: "BLZ", name: "Chileka International Airport", type: "air" }
  ],
  "Zambia": [
    { code: "LUN", name: "Kenneth Kaunda International Airport", type: "air" }
  ],
  "Zimbabwe": [
    { code: "HRE", name: "Harare Robert Gabriel Mugabe Airport", type: "air" },
    { code: "VFA", name: "Victoria Falls Airport", type: "air" }
  ],

  // ============================================
  // OCEANIA
  // ============================================
  "Australia": [
    { code: "SYD", name: "Sydney Kingsford Smith Airport", type: "air" },
    { code: "MEL", name: "Melbourne Tullamarine Airport", type: "air" },
    { code: "BNE", name: "Brisbane Airport", type: "air" },
    { code: "PER", name: "Perth Airport", type: "air" },
    { code: "ADL", name: "Adelaide Airport", type: "air" },
    { code: "SYP", name: "Sydney (Port Botany)", type: "sea" },
    { code: "MEP", name: "Melbourne Port", type: "sea" },
    { code: "BRP", name: "Brisbane Port", type: "sea" },
    { code: "FRM", name: "Fremantle (Perth)", type: "sea" },
    { code: "ADP", name: "Adelaide Port", type: "sea" },
    { code: "DRW", name: "Darwin", type: "both" },
    { code: "GLA", name: "Gladstone", type: "sea" },
    { code: "NEW", name: "Newcastle", type: "sea" },
    { code: "TOW", name: "Townsville", type: "sea" }
  ],
  "Fiji": [
    { code: "NAN", name: "Nadi International Airport", type: "air" },
    { code: "SUV", name: "Suva Nausori Airport", type: "air" },
    { code: "SUP", name: "Suva Port", type: "sea" },
    { code: "LAU", name: "Lautoka", type: "sea" }
  ],
  "French Polynesia": [
    { code: "PPT", name: "Tahiti Faa'a Airport", type: "air" },
    { code: "PAP", name: "Papeete Port", type: "sea" }
  ],
  "Guam": [
    { code: "GUM", name: "Guam Antonio B. Won Pat Airport", type: "air" },
    { code: "APR", name: "Apra Harbor", type: "sea" }
  ],
  "New Caledonia": [
    { code: "NOU", name: "Nouméa La Tontouta Airport", type: "air" },
    { code: "NOP", name: "Nouméa Port", type: "sea" }
  ],
  "New Zealand": [
    { code: "AKL", name: "Auckland Airport", type: "air" },
    { code: "CHC", name: "Christchurch Airport", type: "air" },
    { code: "WLG", name: "Wellington Airport", type: "air" },
    { code: "AKP", name: "Auckland (Ports of Auckland)", type: "sea" },
    { code: "TAU", name: "Tauranga", type: "sea" },
    { code: "LYT", name: "Lyttelton (Christchurch)", type: "sea" },
    { code: "WEL", name: "Wellington Port", type: "sea" },
    { code: "NAP", name: "Napier", type: "sea" }
  ],
  "Papua New Guinea": [
    { code: "POM", name: "Port Moresby Jacksons Airport", type: "air" },
    { code: "LAE", name: "Lae Nadzab Airport", type: "air" },
    { code: "PMP", name: "Port Moresby Port", type: "sea" },
    { code: "LAP", name: "Lae Port", type: "sea" }
  ],
  "Samoa": [
    { code: "APW", name: "Apia Faleolo Airport", type: "air" },
    { code: "APO", name: "Apia Port", type: "sea" }
  ],
  "Solomon Islands": [
    { code: "HIR", name: "Honiara International Airport", type: "air" },
    { code: "HOP", name: "Honiara Port", type: "sea" }
  ],
  "Vanuatu": [
    { code: "VLI", name: "Port Vila Bauerfield Airport", type: "air" },
    { code: "VLP", name: "Port Vila", type: "sea" }
  ],
  "Tonga": [
    { code: "TBU", name: "Fuaʻamotu International Airport", type: "air" },
    { code: "NUK", name: "Port of Nukuʻalofa", type: "sea" }
  ],
  "Kiribati": [
    { code: "TRW", name: "Bonriki International Airport", type: "air" },
    { code: "BET", name: "Betio Port", type: "sea" }
  ],
  "Marshall Islands": [
    { code: "MAJ", name: "Marshall Islands International Airport", type: "air" },
    { code: "MAJ", name: "Port of Majuro", type: "sea" }
  ],
  "Micronesia": [
    { code: "PNI", name: "Pohnpei International Airport", type: "air" },
    { code: "POH", name: "Pohnpei Harbor", type: "sea" }
  ],
  "Nauru": [
    { code: "INU", name: "Nauru International Airport", type: "air" },
    { code: "AIW", name: "Aiwo Port", type: "sea" }
  ],
  "Palau": [
    { code: "ROR", name: "Roman Tmetuchl International Airport", type: "air" },
    { code: "KOR", name: "Koror Port (Malakal Harbor)", type: "sea" }
  ],
  "Tuvalu": [
    { code: "FUN", name: "Funafuti International Airport", type: "air" },
    { code: "FNF", name: "Funafuti Port", type: "sea" }
  ]
};

// Get all ports as a flat array with country information
export const getAllPorts = () => {
  const allPorts = [];
  Object.entries(portsByCountry).forEach(([country, ports]) => {
    ports.forEach(port => {
      allPorts.push({
        ...port,
        country,
        label: `${port.code} - ${port.name}`,
        fullLabel: `${port.code} - ${port.name}, ${country}`
      });
    });
  });
  return allPorts.sort((a, b) => a.code.localeCompare(b.code));
};

// Get ports grouped by region
export const getPortsByRegion = () => {
  const caribbean = [
    "Anguilla", "Antigua and Barbuda", "Aruba", "Bahamas", "Barbados", "Bermuda",
    "Bonaire", "British Virgin Islands", "Cayman Islands", "Cuba", "Curaçao",
    "Dominica", "Dominican Republic", "Grenada", "Guadeloupe", "Haiti", "Jamaica",
    "Martinique", "Montserrat", "Puerto Rico", "Saint Barthélemy",
    "Saint Kitts and Nevis", "Saint Lucia", "Sint Maarten",
    "Saint Vincent and the Grenadines", "Trinidad and Tobago",
    "Turks and Caicos Islands", "US Virgin Islands"
  ];
  
  const centralAmerica = [
    "Belize", "Costa Rica", "El Salvador", "Guatemala", "Honduras", "Nicaragua", "Panama"
  ];
  
  const southAmerica = [
    "Argentina", "Bolivia", "Brazil", "Chile", "Colombia", "Ecuador", "French Guiana",
    "Guyana", "Paraguay", "Peru", "Suriname", "Uruguay", "Venezuela"
  ];
  
  const northAmerica = ["Canada", "Mexico", "United States"];
  
  const europeWest = ["Austria", "Belgium", "France", "Germany", "Ireland", "Luxembourg", "Netherlands", "Switzerland", "United Kingdom"];
  const europeSouth = ["Cyprus", "Greece", "Italy", "Malta", "Portugal", "Spain"];
  const europeNorth = ["Denmark", "Estonia", "Finland", "Iceland", "Latvia", "Lithuania", "Norway", "Poland", "Russia", "Sweden", "Ukraine"];
  const europeEastBalkans = ["Albania", "Azerbaijan", "Belarus", "Bosnia and Herzegovina", "Bulgaria", "Croatia", "Czech Republic", "Georgia", "Hungary", "Kazakhstan", "Kosovo", "Moldova", "Montenegro", "North Macedonia", "Romania", "Serbia", "Slovakia", "Slovenia", "Turkmenistan", "Uzbekistan"];
  
  const middleEast = ["Bahrain", "Iran", "Iraq", "Israel", "Jordan", "Kuwait", "Lebanon", "Oman", "Qatar", "Saudi Arabia", "United Arab Emirates", "Yemen"];
  
  const asiaEast = ["China", "Hong Kong", "Japan", "Macau", "Mongolia", "North Korea", "South Korea", "Taiwan"];
  const asiaSoutheast = ["Brunei", "Cambodia", "Indonesia", "Laos", "Malaysia", "Myanmar", "Philippines", "Singapore", "Thailand", "Timor-Leste", "Vietnam"];
  const asiaSouth = ["Bangladesh", "India", "Maldives", "Nepal", "Pakistan", "Sri Lanka"];
  
  const africaNorth = ["Algeria", "Egypt", "Libya", "Morocco", "Tunisia"];
  const africaWest = ["Benin", "Burkina Faso", "Cameroon", "Cape Verde", "Côte d'Ivoire", "Democratic Republic of the Congo", "Equatorial Guinea", "Gabon", "Gambia", "Ghana", "Guinea", "Guinea-Bissau", "Liberia", "Mali", "Mauritania", "Niger", "Nigeria", "Republic of the Congo", "São Tomé and Príncipe", "Senegal", "Sierra Leone", "Togo"];
  const africaEast = ["Comoros", "Djibouti", "Eritrea", "Ethiopia", "Kenya", "Madagascar", "Mauritius", "Mozambique", "Réunion", "Rwanda", "Seychelles", "Somalia", "South Sudan", "Sudan", "Tanzania", "Uganda"];
  const africaSouth = ["Angola", "Botswana", "Eswatini", "Lesotho", "Malawi", "Namibia", "South Africa", "Zambia", "Zimbabwe"];
  
  const oceania = ["Australia", "Fiji", "French Polynesia", "Guam", "Kiribati", "Marshall Islands", "Micronesia", "Nauru", "New Caledonia", "New Zealand", "Palau", "Papua New Guinea", "Samoa", "Solomon Islands", "Tonga", "Tuvalu", "Vanuatu"];

  const buildRegion = (countries) => countries.filter(c => portsByCountry[c]).map(c => ({ country: c, ports: portsByCountry[c] }));
  
  return {
    "Caribbean": buildRegion(caribbean),
    "Central America": buildRegion(centralAmerica),
    "South America": buildRegion(southAmerica),
    "North America": buildRegion(northAmerica),
    "Europe - Western": buildRegion(europeWest),
    "Europe - Southern": buildRegion(europeSouth),
    "Europe - Northern": buildRegion(europeNorth),
    "Europe - Eastern & Balkans": buildRegion(europeEastBalkans),
    "Turkey": buildRegion(["Turkey"]),
    "Middle East": buildRegion(middleEast),
    "Asia - East": buildRegion(asiaEast),
    "Asia - Southeast": buildRegion(asiaSoutheast),
    "Asia - South": buildRegion(asiaSouth),
    "Africa - North": buildRegion(africaNorth),
    "Africa - West & Central": buildRegion(africaWest),
    "Africa - East": buildRegion(africaEast),
    "Africa - South": buildRegion(africaSouth),
    "Oceania & Pacific": buildRegion(oceania)
  };
};

// Get countries sorted alphabetically
export const getCountriesSorted = () => {
  return Object.keys(portsByCountry).sort();
};

// Search ports by code or name
export const searchPorts = (query) => {
  if (!query || query.length < 2) return [];
  const q = query.toLowerCase();
  const allPorts = getAllPorts();
  return allPorts.filter(port => 
    port.code.toLowerCase().includes(q) ||
    port.name.toLowerCase().includes(q) ||
    port.country.toLowerCase().includes(q)
  ).slice(0, 50);
};

export default portsByCountry;
